<div class="container">
  <app-loading [showLoading]="isLoading"></app-loading>
  <h1 class="header">
    <span class="title">Amazon Connect の連携</span>
    <button
      type="button"
      class="close-button"
      aria-label="閉じる"
      [disabled]="isLoading"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <form class="main" (submit)="onSubmit($event)">
    <div class="form">
      <div class="field">
        <label class="label" for="amazon-connect-skill-map"
          >連携 SkillMap * :</label
        >
        <div class="value">
          <app-select
            id="amazon-connect-skill-map"
            [options]="skillMapOptions"
            [selectedOption]="selectedSkillMap"
            [disabled]="isLoading"
            [showError]="!isLoading && selectedSkillMap.id === ''"
            (selectedOptionChange)="changeSkillMap($event)"
          ></app-select>
          @if (!isLoading && selectedSkillMap.id === '') {
            <p class="input-error" role="alert">
              {{ skillMapError || '連携 SkillMap を選択してください。' }}
            </p>
          }
        </div>
      </div>
      <div class="field">
        <label class="label" for="amazon-connect-cidr">送信元 CIDR :</label>
        <div class="input-with-error">
          <div class="tag-input-row">
            <input
              id="amazon-connect-cidr"
              class="input"
              placeholder="203.0.113.0/24"
              [formControl]="cidrInput"
              (keydown.enter)="$event.preventDefault(); addCidr()"
            />
            <button
              type="button"
              rectangle
              variant="secondary"
              [disabled]="isLoading || cidrInput.value.trim() === ''"
              (click)="addCidr()"
            >
              追加
            </button>
          </div>
          @if (cidrError) {
            <div class="input-error" role="alert">{{ cidrError }}</div>
          }
          <div class="tag-list">
            @for (cidr of allowedCidrs; track cidr) {
              <span class="tag-chip"
                >{{ cidr
                }}<button
                  type="button"
                  class="tag-remove"
                  [disabled]="isLoading"
                  [attr.aria-label]="cidr + 'を削除'"
                  (click)="removeCidr(cidr)"
                >
                  <mat-icon>close</mat-icon>
                </button></span
              >
            }
          </div>
        </div>
      </div>
      @if (allowedCidrs.length === 0) {
        <p class="warning">
          {{
            active
              ? '有効化する場合は送信元 CIDR を 1 件以上登録してください'
              : '送信元 CIDR が未設定の間は入稿がすべて拒否されます。'
          }}
        </p>
      }
      @if (hasUnrestrictedCidr) {
        <p class="warning" role="alert">
          送信元の制限が極端に緩い CIDR が含まれています。 0.0.0.0/0
          を登録すると送信元の制限がなくなります。API
          キーの管理に十分注意してください。::/0 も同様です。
        </p>
      }
      @if (errorMessage) {
        <div class="error-message" role="alert">{{ errorMessage }}</div>
      }
    </div>
    <div class="footer">
      <button
        type="button"
        rectangle
        variant="secondary"
        [disabled]="isLoading"
        (click)="close()"
      >
        キャンセル
      </button>
      <button
        type="submit"
        rectangle
        variant="primary"
        [disabled]="isSaveDisabled()"
      >
        保存
      </button>
    </div>
  </form>
</div>
